import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "interfaces/user";

export interface UserState {
  user: User | null;
}

const initialState: UserState = {
  user: null,
};

const userSlice = createSlice({
  name: "userReducer",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setUsername: (state, action: PayloadAction<string>) => {
      if (state.user) state.user.username = action.payload;
    },
  },
});

export const { setUser, setUsername } = userSlice.actions;
export default userSlice.reducer;
